const register = {
    // view strucutre
    title: String("Registrarse"),
    welcomeMsg: String("Bienvenido a AgroUPAdvisor!"),
    credentialAsk: String("Rellene el formulario para crear una nueva cuenta"),
    mandatoryFields: String("Los campos marcados con (*) son obligatorios."),
    passStrength: String("Seguridad de la contraseña"),
    passLowStrength: String("Débil"),
    passMidStrength: String("Media"),
    passHighStrength: String("Fuerte"),
    policyAgreementPrefix: String("Estoy de acuerdo con la "),
    policyAgreement: String("Política de Privacidad"),
    createAccount: String("Crear cuenta"),
    forgotPass: String("Has olvidado tu contraseña?"),
    login: String("Ya tengo una cuenta"),
    personalDataTitle: String("Datos personales"),
    requiredFieldsMissing: String("Hay algún problema con los campos obligatorios:\n"),
    cancelButton: String("Cerrar"),
    
    // fields
    username: String("Nombre de usuario"),
    password: String("Contraseña"),
    email: String("Correo electrónico"),
    confirmPassword: String("Confirma contraseña"),
    firstName: String("Nombre"),
    lastName1: String("Primer apellido"),
    lastName2: String("Segundo apellido"),
    phone: String("Teléfono"),
    nif: String("DNI o NIF"),
    userSearcher: String("Introduce tu dirección para autocompletar tus datos"),
    address: String("Dirección"),
    addressNum: String("Número"),
    city: String("Ciudad"),
    province: String("Provincia"),
    country: String("País"),
    region: String("Comarca"),
    postalCode: String("Código postal"),
    payAccountNumber: String("IBAN"),

    // Placeholders
    registerGoogleAskAddressPlaceholder: String("Buscar dirección..."),

    // Errors
    errorFieldRequired: String("Este campo es obligatorio"),
    errorInvalidField: String("Campo invalido. Este campo solo puede contener letras, guiones (-) y espacios."),
    errorInvalidNif: String("Formato invalido. Este campo debe contener 8 números mas una letra. 01234567A"),
    errorFieldNumeric: String("Este campo solo puede contener números"),
    errorPassConfirm: String("Las contraseñas deben ser identicas"),
    errorFieldEmail: String("Dirección de correo invalida."),
    errorInvalidLength: String("Número de caracteres mínimo: {length}"),
    errorInvalidLengthRange: String("Número de caracteres debe ser entre {length_min} y {length_max}"),
    errorPassStrength: String("La contraseña debe contener almenos una letra mayúscula, una minúscula, un número y un simbolo"),
    errorPolicyAgreement: String("Es necesaria la aceptación de la política de privacidad."),

    // User response
    userCreationSuccess: String("La cuenta ha sido creada correctamente. Recuerda que la cuenta se debe activar mediante el email de confirmación."),
    userCreationFailedUsername: String("No se ha podido crear la cuenta, el nombre de usuario ya esta en uso."),
    userCreationFailedEmail: String("No se ha podido crear la cuenta, el email ya esta asociado a una cuenta.",) 
};

export default register;